import { styled, Typography } from '@material-ui/core';

export const UnderlineTypography = styled(Typography)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.primary.main}`,
}));
